<script setup lang="ts">
import { Order } from '@/@types/order'
import { Button } from '@/components/ui/button'
import { DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { useForm } from '@inertiajs/vue3'
import { Loader2 } from 'lucide-vue-next'

const { order } = defineProps<{ order: Order }>()

const form = useForm({
    status: 'paid',
})
</script>

<template>
    <DialogContent class="font-inter p-8 text-gray-800">
        <DialogHeader class="flex gap-2">
            <DialogTitle class="text-2xl">{{ $t('Do you confirm payment for this order?') }}</DialogTitle>
            <DialogDescription class="text-sm font-normal text-gray-800">
                <template v-if="order.status == 'released'">
                    {{ $t('Upon confirmation, an email will be sent to the buyer confirming the order.') }}
                </template>
                <template v-else>
                    {{ $t('Upon confirmation, an email will be sent to the buyer confirming the order and making the tickets available for management.') }}
                </template>
            </DialogDescription>
        </DialogHeader>
        <DialogFooter>
            <form
                @submit.prevent="form.patch(`/admin/orders/${order.id}/update_status`, { preserveState: false })"
                class="flex w-full flex-col gap-6"
            >
                <div class="flex justify-between pt-6">
                    <DialogClose>
                        <Button type="button" variant="ghost" class="text-primary hover:text-primary hover:bg-primary/3 min-w-2/12">
                            {{ $t('Back') }}
                        </Button>
                    </DialogClose>
                    <Button :disabled="form.processing" class="min-w-2/12">
                        <template v-if="!form.processing">
                            {{ $t('Paid order') }}
                        </template>
                        <template v-if="form.processing">
                            <span>
                                <Loader2 class="animate-spin" />
                                <span class="sr-only"></span>
                            </span>
                        </template>
                    </Button>
                </div>
            </form>
        </DialogFooter>
    </DialogContent>
</template>
